import styled from "styled-components";
import { remCalc, hexToRGB } from "../theme/style-utils-coras-nua";
import { space } from "styled-system";
import defaultTheme from "../theme/theme-test-override";

const LoadingIcon = styled("div")`
${space}
    width: ${props =>
        props.size === "small"
            ? remCalc(16)
            : props.size === "medium"
            ? remCalc(32)
            : props.size === "large"
            ? remCalc(48)
            : remCalc(16)};
    height: ${props =>
        props.size === "small"
            ? remCalc(16)
            : props.size === "medium"
            ? remCalc(32)
            : props.size === "large"
            ? remCalc(48)
            : remCalc(16)};
    border-width: ${props =>
        props.size === "small"
            ? remCalc(16 / 8)
            : props.size === "medium"
            ? remCalc(32 / 10.66)
            : props.size === "large"
            ? remCalc(48 / 12)
            : remCalc(16 / 8)};
    &:after {
        width: ${props =>
            props.size === "small"
                ? remCalc(16)
                : props.size === "medium"
                ? remCalc(32)
                : props.size === "large"
                ? remCalc(64)
                : remCalc(16)};
        height: ${props =>
            props.size === "small"
                ? remCalc(16)
                : props.size === "medium"
                ? remCalc(32)
                : props.size === "large"
                ? remCalc(64)
                : remCalc(16)};
    }
    position: relative;
    text-indent: -9999em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: rotate 1.1s infinite linear;
    animation: rotate 1.1s infinite linear;
    border-radius: 50%;
    border-style: solid;
    border-top-color: ${props => hexToRGB(props.theme.colors.primary, 0.3)};
    border-right-color: ${props => hexToRGB(props.theme.colors.primary, 0.3)};
    border-bottom-color: ${props => hexToRGB(props.theme.colors.primary, 0.3)};
    border-left-color: ${props => hexToRGB(props.theme.colors.primary)};
    &:after {
        border-radius: 50%;
    }
    @-webkit-keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
`;

LoadingIcon.defaultProps = {
    mx: "auto",
    my: [10, 10, 18],
    theme: {
        ...defaultTheme
    }
};

export default LoadingIcon;
